import { Controller, useFormContext } from "react-hook-form";

import { useThemePreviewContext } from "containers/admin/clients/client/theme-page/contexts/theme-preview-context";
import { FieldLabel } from "ui/forms";
import { ToggleButtonGroup } from "ui/toggle-button-group";
import { TypographyKeys } from "containers/admin/clients/client/theme-page/preview/preview.types";
import { TEXT_ALIGNMENT_OPTIONS } from "containers/admin/clients/client/theme-page/preview/sub-tabs/typography/components/text-alignment/text-alignment.consts";
interface TextAlignmentProps {
  name: string;
  label: string;
  sectionName: TypographyKeys;
}

const TextAlignment = ({ name, label, sectionName }: TextAlignmentProps) => {
  const { isEditMode, setTypography, typography } = useThemePreviewContext();
  const { control } = useFormContext();

  const handleAlignmentChange = (value: string, onChange: (value: string) => void) => {
    if (!isEditMode) return;

    onChange(value);

    if (typography) {
      setTypography((prev) => {
        if (!prev) return prev;
        return {
          ...prev,
          [sectionName]: {
            ...prev[sectionName],
            alignment: value,
          },
        };
      });
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <div>
          <FieldLabel name={name}>{label}</FieldLabel>
          <div className="mt-1.5">
            <ToggleButtonGroup
              groupName={name}
              options={TEXT_ALIGNMENT_OPTIONS}
              value={field.value}
              onChange={(value) => handleAlignmentChange(value, field.onChange)}
              sx={{ width: "100%" }}
              size="md"
              disabled={!isEditMode}
            />
          </div>
        </div>
      )}
    />
  );
};

export default TextAlignment;
